import { Component, Input } from '@angular/core';

@Component({
  selector: 'wk-media',
  templateUrl: './wk-media.component.html',
  standalone: false,
})
export class WKMediaComponent {
  @Input()
  selectedIndex;
  constructor() {}
}
